import React from "react";
import { GetSuccessorListing } from '../../../redux/features/SuccessorService';
import UserManagementWrapper from "../../Common/UserManagementWrapper";

const ActiveSuccessor = ({ filteredData }) => { // NOSONAR
  return (
    <UserManagementWrapper
      fetchFunction={GetSuccessorListing}
      fetchArgs={{
        search: "",
        role: 4,
        status: "1",
      }}
      selector={(state) => state.successor.getSuccessorListing}
      detailRoute="/successor"
      filteredData={filteredData}
    />
  );
};

export default ActiveSuccessor;
